var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPaperPlane(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2578_13399)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.74034 7.24034C1.38793 7.35488 1.36724 7.84562 1.70875 7.98941L8.36124 10.7905L13.576 5.57573C13.8103 5.34142 14.1902 5.34142 14.4245 5.57573C14.6588 5.81005 14.6588 6.18995 14.4245 6.42426L9.20977 11.639L12.0108 18.2914C12.1546 18.6329 12.6453 18.6122 12.7599 18.2598L17.8227 2.68139C17.9237 2.37053 17.6295 2.07632 17.3186 2.17734L1.74034 7.24034ZM8.04211 11.9581L1.24308 9.09537C-0.122952 8.5202 -0.0401714 6.55723 1.36943 6.0991L16.9477 1.0361C18.1911 0.631993 19.368 1.80888 18.9639 3.05228L13.9011 18.6307C13.443 20.0403 11.48 20.1231 10.9048 18.7571L8.04211 11.9581Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2578_13399"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaperPlane);
export default __webpack_public_path__ + "static/media/paper-plane.dbefa7cb837f1c36abd107694ee457b8.svg";
export { ForwardRef as ReactComponent };